import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import BeachFooter from '../Footer/beachFooter'

const Layout = ({ props, children, ...rest }) => {
    const checkBeachThemeClassName = document.body.className == 'liquidationTwo beachLiquidation'
    return (
        <div className="app-wrapper">
            {/* <h1>Hi {currentUser.name}!</h1> */}
            <Header />
            <div className="main-container">{children}</div>
            {checkBeachThemeClassName ? <BeachFooter /> : <Footer />}
        </div>
    )
}

export default Layout
